import WebServiceRequest from "@/libs/Api/WebServiceRequest";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { initialAbility } from "@/libs/acl/config";

class BaseLevelLoyaltyRequest extends WebServiceRequest {
    constructor(context, tag, method = "post") {
        super(context);
        super.setTag(tag);
        this.method = method;
    }

    async send(successCallback, errorCallback) {
        if (this.method === "get") return this.get(successCallback, errorCallback);
        return this.fetch(successCallback, errorCallback);
    }
}

class Create extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/Create", "post");
    }
}

class Update extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/Update", "post");
    }
}

class Delete extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/Delete", "post");
    }
}

class GetById extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/GetById", "get");
    }

    setRequestParam(value) {
        const v = value || {};
        super.setRequestParam({ levelLoyaltyId: Number(v.levelLoyaltyId || v.id || 0) });
    }
}

class List extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/List", "get");
    }

    setRequestParam(value) {
        const v = value || {};
        const params = {
            PageNumber: Math.max(1, Number(v.PageNumber || v.pageNumber || 1)),
            Count: Math.max(1, Number(v.Count || v.count || 10))
        };

        const search = String(v.Search ?? v.search ?? "").trim();
        if (search.length > 0) {
            params.Search = search;
        }

        super.setRequestParam(params);
    }
}

class GetListLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/GetListLevelLoyaltUser", "get");
    }

    setRequestParam(value) {
        const v = value || {};
        const params = {
            PageNumber: Math.max(1, Number(v.PageNumber || v.pageNumber || 1)),
            Count: Math.max(1, Number(v.Count || v.count || 10))
        };

        const search = String(v.Search ?? v.search ?? "").trim();
        if (search.length > 0) {
            params.Search = search;
        }

        const levelId = Number(
            v.LevelLoyaltyId ??
            v.levelLoyaltyId ??
            v.levelLoyaltId ??
            0
        );

        if (levelId > 0) {
            params.LevelLoyaltyId = levelId;
        }

        super.setRequestParam(params);
    }
}


class DeleteLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/DeleteLevelLoyaltUser", "post");
    }

    setRequestParam(value) {
        const v = value || {};
        super.setRequestParam({
            levelLoyaltyUserId: Number(v.levelLoyaltyUserId || v.id || 0)
        });
    }
}

class CreatelevelLoyaltUserbyAdmin extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/CreatelevelLoyaltUserbyAdmin", "post");
    }
}

class UpdateLevelLoyaltUserByAdmin extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/UpdateLevelLoyaltUserByAdmin", "post");
    }
}

class GetHistoryLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/GetListLevelLoyaltUserHistory", "get");
    }

    setRequestParam(value) {
        const v = value || {};
        const params = {
            PageNumber: Math.max(1, Number(v.pageNumber || 1)),
            Count: Math.max(1, Number(v.count || 10)),
            LevelLoyaltyUserId: Number(v.LevelLoyaltyUserId || 0)
        };
        super.setRequestParam(params);
    }
}

class CreateHistoryLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/CreateLevelLoyaltUserHistory", "post");
    }
}

class UpdateHistoryLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/UpdateLevelLoyaltUserHistory", "post");
    }
}

class DeleteHistoryLevelLoyaltUser extends BaseLevelLoyaltyRequest {
    constructor(context) {
        super(context, "LevelLoyalty/DeleteLevelLoyaltUserHistory", "post");
    }

    setRequestParam(value) {
        const v = value || {};
        super.setRequestParam({
            id: Number(v.id || 0)
        });
    }
}

export {
    Create,
    Update,
    Delete,
    GetById,
    List,
    GetListLevelLoyaltUser,
    CreateHistoryLevelLoyaltUser,
    DeleteLevelLoyaltUser,
    DeleteHistoryLevelLoyaltUser,
    GetHistoryLevelLoyaltUser,
    CreatelevelLoyaltUserbyAdmin,
    UpdateLevelLoyaltUserByAdmin,
    UpdateHistoryLevelLoyaltUser
};